const TOGGLE_CENTRAL_PAYMENT = "TOGGLE_CENTRAL_PAYMENT";

const toggleCentralPayment = (useNewModule) => ({
  type: TOGGLE_CENTRAL_PAYMENT,
  payload: useNewModule, // true: 使用新模組(central-payment), false: 使用舊模組
});

const openCentralPaymentModal = (modalType, dMethod) => ({
  type: 'OPEN_CP_MODAL',
  payload: { modalType, dMethod }, // 'deposit' 或 'withdrawal'
});

const closeCentralPaymentModal = () => ({
  type: 'CLOSE_CP_MODAL',
});

export { TOGGLE_CENTRAL_PAYMENT, toggleCentralPayment, openCentralPaymentModal, closeCentralPaymentModal };

